import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail } from 'firebase/auth';
import { app } from '../firebase';

const auth = getAuth(app);

const SignUpPage = () => {
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [validationError, setValidationError] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();
    setValidationError('');
    if (email !== confirmEmail) {
      setValidationError('Emails do not match.');
      return;
    }
    if (password !== confirmPassword) {
      setValidationError('Passwords do not match.');
      return;
    }
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      await sendEmailVerification(userCredential.user);
      alert('Registration successful! Please check your email to verify your account before logging in.');
      // Automatically redirected in App.js once user is created
    } catch (error) {
      setValidationError(error.message);
    }
  };

  return (
    <div style={{ minHeight: '100vh', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #67c6ff 100%)' }}>
      
      <form onSubmit={handleSignup} className="p-12 max-w-md w-full border border-gray-100 rounded-2xl shadow-2xl bg-white mx-auto" style={{ boxShadow: '0 8px 32px 0 rgba(30,60,114,0.18)', zIndex: 1, position: 'relative' }}>
      <h1 className="text-3xl font-extrabold text-center mb-10" style={{
  fontSize: 44,
  letterSpacing: 2,
  fontFamily: 'Poppins, Montserrat, Segoe UI, Arial, sans-serif',
  color: '#fff',
  textShadow: '0 4px 24px rgba(30,60,114,0.22)',
  fontWeight: 900,
}}>Sign Up</h1>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className="block w-full px-5 py-4 text-lg border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 shadow-sm transition-all duration-200"
          style={{ fontSize: 20, marginBottom: 0 }}
          required
        />
        <input
          type="email"
          value={confirmEmail}
          onChange={(e) => setConfirmEmail(e.target.value)}
          placeholder="Confirm Email"
          className="block w-full px-5 py-4 text-lg border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 shadow-sm transition-all duration-200"
          style={{ fontSize: 20, marginBottom: 0 }}
          required
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="block w-full px-5 py-4 text-lg border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 shadow-sm transition-all duration-200"
          style={{ fontSize: 20, marginBottom: 0 }}
          required
        />
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm Password"
          className="block w-full px-5 py-4 text-lg border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 shadow-sm transition-all duration-200"
          style={{ fontSize: 20, marginBottom: 0 }}
          required
        />
      </div>
      {validationError && <p className="text-red-600 text-sm text-center" style={{ marginBottom: 16 }}>{validationError}</p>}
      <button
        type="submit"
        className="bg-blue-700 text-white w-full px-8 py-4 rounded-xl font-bold text-xl shadow-md hover:bg-blue-800 hover:shadow-lg transition-all duration-200 transform hover:scale-105"
        style={{ marginTop: 12 }}
      >
        Sign Up
      </button>
            <div style={{ textAlign: 'center', marginTop: 32, fontSize: 20, fontWeight: 600 }}>
          <span style={{ color: '#fff', fontSize: 22, fontWeight: 700, marginRight: 8 }}>Already have an account?</span>
          <a href="/auth" style={{ color: '#fff', fontWeight: 700, textDecoration: 'underline', marginLeft: 6, fontSize: 20 }}>
            Login
          </a>
        </div>
      </form>
    </div>
  );
};

export default SignUpPage;
